import { getOperations } from "../../../../../actions/Utilities/Common";
import { useQuery } from "react-query";

export default function useOperations() {
  return useQuery("Operations", getOperations, {
    refetchOnWindowFocus: false,
    staleTime: Infinity,
  });
}
